module.exports = __webpack_public_path__ + "media/images/official/about_mv_pc-634854a453deeccd7d0ebd8214834734.jpg";